import API from "./API"

const fetchLeafUrl = orgNodeId => API.get(`leafurl/${orgNodeId}/`)

const postLeafCode = payload => API.post(`leaf-create/`, payload)

export default { fetchLeafUrl, postLeafCode }
